module.exports = __webpack_public_path__ + "img/nang-luc-cambridge-head.1e18dcab.png";